<div *ngIf="loaderVisible$ | async">
    <!-- Full-screen overlay to lighten the background and block interactions -->
    <div class="loading-overlay">
        <div class="loader">
            <img src="assets/img/core/Loadding.gif" alt="Loading..." class="loader-gif">
        </div>
        <!-- Centered loader -->
    </div>
</div>